module.exports = __webpack_public_path__ + "static/iphone-ce9e2c1aeac343532a4e2523f3234bf0.png";